export default {
  operation: {
    type: null,
    bookingId: null,
    booking: null,
  },
  isBusy: false,
}
